import React from "react";
import StyledMessage from "components/ui/StyledMessage";
import { useUser } from "components/hooks/useUser";

export function SummerLawEnrollmentInfo() {
  const { messages: { summerLawInfo: message } = {} } = useUser(
    (user) => user.enrollmentResources
  );

  const feesWarning = true;

  return (
    <StyledMessage>
      <div dangerouslySetInnerHTML={{ __html: message.descrlong }} />
      {feesWarning && (
        <p style={{ marginTop: `10px` }}>
          If you drop all your summer sessions classes, you will be subject to{" "}
          <a href="#">summer fees</a>
        </p>
      )}
    </StyledMessage>
  );
}

SummerLawEnrollmentInfo.displayName = "SummerLawEnrollmentInfo";
